import type { AppEnvironment, RuntimeAppConfig } from './environment.model';

const RUNTIME_SCALAR_KEYS: Array<keyof RuntimeAppConfig> = [
  'apiUrl',
  'appName',
  'version',
  'logLevel',
  'loginUrl',
  'explorePropertiesUrl',
  'propertyDetailsUrl',
  'inactivityTimeout',
  'warningTimeout',
  'sessionExpiryWarningMs',
  'authFlowDebug',
  'digilockerAllowLocalhostRedirect',
  'digilockerLocalTunnelUrl',
  'digilockerRedirectUrl',
];

export function applyRuntimeConfig(
  target: AppEnvironment,
  source: RuntimeAppConfig,
): void {
  for (const key of RUNTIME_SCALAR_KEYS) {
    const value = source[key];
    if (value !== undefined) {
      Object.assign(target, { [key]: value });
    }
  }

  if (source.firebase) {
    target.firebase = {
      ...target.firebase,
      ...source.firebase,
    };
  }
}
